"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFlowContractAddress = exports.toFlowContractAddress = exports.flowContractRegExp = void 0;
exports.flowContractRegExp = /^A\.0*x*[0-9a-f]{16}\.[A-Za-z]{3,}/;
function toFlowContractAddress(str) {
    if (isFlowContractAddress(str)) {
        return str;
    }
    throw new Error("Not an Flow's contract address");
}
exports.toFlowContractAddress = toFlowContractAddress;
function isFlowContractAddress(x) {
    return exports.flowContractRegExp.test(x);
}
exports.isFlowContractAddress = isFlowContractAddress;
